import { render, staticRenderFns } from "./VUserBlock.vue?vue&type=template&id=6c2438ac&"
import script from "./VUserBlock.vue?vue&type=script&lang=ts&"
export * from "./VUserBlock.vue?vue&type=script&lang=ts&"
import style0 from "./VUserBlock.vue?vue&type=style&index=0&id=6c2438ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports